module.exports = "<h2>Main Concepts<h3 class=\"fragment\">Null Safety</h3><h3 class=\"fragment\">Compatibility</h3><h3 class=\"fragment\">Boilerplate Reduction</h3><h3 class=\"fragment\">Multi-platform (full-stack)</h3></h2>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/02-overview/03.pug
// module id = 320
// module chunks = 1